export default __webpack_public_path__ + "static/media/Footer-animals.094fe1ff.png";